import React from 'react';
import { withStyles } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Chip from '@material-ui/core/Chip';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

import axiosInstance, { API_URL } from '../common/Constants';
import axios from 'axios';
import ImgsViewer from 'react-images-viewer';

import EntryPoint from './EntryPoint';
import TitleText from '../common/TitleText';
// import swal from 'sweetalert';

const styles = (theme) => ({
  traceDetailContainer: {
    padding: theme.spacing(7, 20, 10),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(5, 10, 10),
    },
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(3, 5, 7),
    },
  },
  traceCardRoot: {
    display: 'table',
    width: '90%',
    margin: 'auto',
    padding: theme.spacing(1, 3),
    borderRadius: '20px',
    boxShadow: '0px 10px 10px 0 rgba(0, 0, 0, 0.02)',
    // border: '1px solid #000',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      width: '100%',
      padding: theme.spacing(1, 0),
    },
  },
  stampDiv: {
    marginBottom: '0.5em',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
      width: '100%',
      '& img': {
        width: '40%',
      },
    },
    [theme.breakpoints.down('xs')]: {
      '& img': {
        width: '55%',
      },
    },
  },
  placeTitleDiv: {
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
      width: '100%',
    },
  },
  placeTitle: {
    display: 'inline-block',
    borderBottom: `5px solid ${theme.palette.primary.main}`,
    fontSize: '1.5em',
    fontWeight: 700,
    color: theme.palette.secondary.main,
  },
  placeAddr: {
    fontSize: '0.8em',
    marginBottom: theme.spacing(1),
  },
  placeMainImgDivWeb: {
    display: 'flex',
    // width: '100%',
    // height: '100%',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
    '& img': {
      borderRadius: '20px',
      width: '100%',
      height: 'auto',
      cursor: 'pointer',
    },
  },
  placeMainImgDivMobile: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      width: '100%',
      padding: '0 10%',
      marginBottom: theme.spacing(2),
    },
  },
  chipButtonDiv: {
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
  placeStampTourBtn: {
    backgroundColor: theme.palette.primary.point,
  },
  courseDiv: {
    padding: theme.spacing(7, 2, 0), //'2em 1em 0',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(5, 1, 0),
    },
  },
  courseItemGrid: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(1),
    },
  },
  courseImg: {
    width: '80%',
    height: '80%',
    marginBottom: theme.spacing(1),
    WebkitTouchCallout: 'none',
  },
  courseName: {
    fontSize: '1.2em',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1em',
    },
  },
});

class TraceDetail extends React.Component {
  constructor(props) {
    super(props);
    this.popup = React.createRef();
    this.state = {
      isEntryPointDialogOpen: false,
      courseId: this.props.courseId,
      tracePlace: '',
      //selectedCourse: '',
      isImgViewerOpen: false,
      popupMode: 0,
      popup: false,
      refresh: true,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.isQueryParam && nextProps.courseId !== '' && nextProps.stampId !== null) {
      document.body.style.overflowY = 'hidden';
      if (
        navigator.userAgent.match(/mobile/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/^(safari|(?!chrome).)*$/gi)
      ) {
        document.body.style.overflow = 'hidden';
      }

      return { courseId: nextProps.courseId, popupMode: nextProps.mode, popup: true };
    }

    if (prevState.courseId !== nextProps.courseId) {
      return { refresh: true, courseId: nextProps.courseId };
    }

    return null;
  }

  refreshList() {
    if (this.state.refresh === true) {
      let buff = [];

      axios
        .get(`${API_URL}/course/info?courseId=${this.state.courseId}`, { headers: { Pragma: 'no-cache' } })
        .then((res) => {
          //this.setState({ refresh: false });
          buff = res.data;

          // 개별 스탬프 완주했는지 아닌지 확인하는 코드
          // if (res.data && res.data.stamp && this.props.userStampList && this.props.userStampList.length > 0) {
          //   for (let i = 0; i < res.data.stamp.length; i++) {
          //     for (let j = 0; j < this.props.userStampList.length; j++) {
          //       if (res.data.stamp[i].id === this.props.userStampList[j]) {
          //         buff.stamp[i].isCompleted = true;
          //       }
          //     }
          //   }
          // }

          this.setState({ tracePlace: buff, stampId: this.props.stampId, refresh: false });
        })
        .then(() => {
          if (this.props.userInfo && this.props.userInfo.course) {
            for (let i = 0; i < this.props.userInfo.course.length; i++) {
              if (this.props.userInfo.course[i].id === this.state.tracePlace.id) {
                this.setState({ isSelectedTraceCompleted: true });
              }
            }
          }
        });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    this.refreshList();
  }

  /*
  modalOpenKey(courseId) {
    let course = null;
    for (let i = 0; i < this.tracePlace.length; i++) {
      if (this.tracePlace[i].id === courseId) {
        course = this.tracePlace[i];
        break;
      }
    }

    if (course != null) {
      this.setState({ selectedCourse: course });
      document.getElementById('modalContainer').style.display = 'block';
      // document.body.style.position = 'fixed';
      document.body.style.overflowY = 'hidden';
    }
  }
  */

  componentDidMount() {
    this.refreshList();

    let buff = [];

    axios.get(`${API_URL}/course/info?courseId=${this.state.courseId}`, { headers: { Pragma: 'no-cache' } }).then((res) => {
      buff = res.data;
      if (res.data && res.data.stamp && this.props.userStampList && this.props.userStampList.length > 0) {
        for (let i = 0; i < res.data.stamp.length; i++) {
          for (let j = 0; j < this.props.userStampList.length; j++) {
            if (res.data.stamp[i].id === this.props.userStampList[j]) {
              buff.stamp[i].isCompleted = true;
            }
          }
        }
      }

      this.setState({ tracePlace: res.data, stampId: this.props.stampId });
    });
  }

  componentWillUnmount() {
    this.props.handleState('isSelectedTraceCompleted', false);
    document.body.style.overflowY = 'inherit';
    if (
      navigator.userAgent.match(/mobile/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/^(safari|(?!chrome).)*$/gi)
    ) {
      document.body.style.overflow = 'inherit';
    }
  }

  openImgView = () => {
    this.setState({ isImgViewerOpen: true });
  };

  closeImgView = () => {
    this.setState({ isImgViewerOpen: false });
  };

  modalOpen = (stamp) => {
    console.log('modal open');
    // console.log(stamp);
    this.setState({ stampId: stamp.id, stampName: stamp.name, popupMode: 2, popup: true }, () => {
      document.body.style.overflowY = 'hidden';
      if (
        navigator.userAgent.match(/mobile/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/^(safari|(?!chrome).)*$/gi)
      ) {
        document.body.style.overflow = 'hidden';
      }
    });

    axiosInstance
      .get(`${API_URL}/review/infoByStampId?userId=${localStorage.getItem('loggedin')}&stampId=${stamp.id}`, {})
      .then((res) => {
        let bFound = false;

        if (res.data) {
          bFound = true;
        }
        if (bFound) {
          this.setState({ stampId: stamp.id, stampName: stamp.name, popupMode: 2, popup: true }, () => {
            document.body.style.overflowY = 'hidden';
            if (
              navigator.userAgent.match(/iPhone/i) ||
              navigator.userAgent.match(/iPod/i) ||
              navigator.userAgent.match(/iPad/i) ||
              navigator.userAgent.match(/^(safari|(?!chrome).)*$/gi)
            ) {
              document.body.style.overflow = 'hidden';
            }
          });

          if (this.popup.current) {
            this.popup.current.modalOpen();
            this.popup.current.refreshData(stamp.id);
          }
        } else {
          this.setState({ stampId: stamp.id, popupMode: 1, popup: true }, () => {
            document.body.style.overflowY = 'hidden';
            if (
              navigator.userAgent.match(/iPhone/i) ||
              navigator.userAgent.match(/iPod/i) ||
              navigator.userAgent.match(/iPad/i) ||
              navigator.userAgent.match(/^(safari|(?!chrome).)*$/gi)
            ) {
              document.body.style.overflow = 'hidden';
            }
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });

    //this.popup.current.refreshData();
    //document.getElementById('modalContainer').style.display = 'block';
    // document.body.style.position = 'fixed';
    //document.body.style.overflowY = 'none';
  };

  modalClose = () => {
    this.setState({ popup: false }, () => {
      document.body.style.overflowY = 'inherit';
      if (
        navigator.userAgent.match(/mobile/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/^(safari|(?!chrome).)*$/gi)
      ) {
        document.body.style.overflow = 'inherit';
      }
    });
  };

  /*
  modalClose() {
    document.getElementById('modalContainer').style.display = 'none';
    // document.body.style.position = 'inherit';
    document.body.style.overflowY = 'inherit';
  }
  */

  isVisit(key) {
    let rtn = false;
    if (this.props.userInfo && this.props.userInfo.stamp) {
      for (let i = 0; i < this.props.userInfo.stamp.length; i++) {
        // if (key === this.props.userInfo.stamp[i]) {
        if (key === this.props.userInfo.stamp[i].id) {
          rtn = true;
        }
      }
    }
    return rtn;
  }

  render() {
    const { classes } = this.props;
    const { tracePlace, isImgViewerOpen, stampId, stampName } = this.state;

    // console.log(this.props.userInfo.course, 'course');
    // console.log(this.state.tracePlace, 'tracePlace');
    // console.log(tracePlace, 'tracePlace');
    return (
      <React.Fragment>
        <EntryPoint
          ref={this.popup}
          courseInfo={tracePlace}
          //selectedCourse={selectedCourse}
          onClose={this.modalClose}
          mode={this.state.popupMode}
          showDialog={this.state.popup}
          courseId={this.state.courseId}
          stampId={stampId}
          stampName={stampName}
          reviewId={this.props.reviewId}
          isQueryParam={this.props.isQueryParam}
        />
        <div className={classes.traceDetailContainer}>
          <Card className={classes.traceCardRoot}>
            <CardContent>
              <div style={{ paddingBottom: '1em' }}>
                <ArrowBackIosIcon
                  color="primary"
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    if (this.props.queryStr && this.props.queryStr.course) {
                      this.props.handleDetailToList();
                    } else {
                      this.props.handleState('traceState', 'list');
                    }
                  }}
                />
              </div>
              {this.state.isSelectedTraceCompleted && (
                <div className={classes.stampDiv}>
                  <img
                    src={'/images/mypage/completed_stamp@2x.png'}
                    alt={'completed_stamp'}
                    onContextMenu={(e) => e.preventDefault()}
                    style={{ WebkitTouchCallout: 'none' }}
                  />
                </div>
              )}
              <Grid container spacing={2}>
                <Grid item container xs={12} sm={12} md={8} style={{ flexDirection: 'column' }}>
                  <div className={classes.placeTitleDiv}>
                    <TitleText title={tracePlace && tracePlace.name ? tracePlace.name : ''} type={'traceDetail'} />
                    <div className={classes.placeAddr}>{tracePlace && tracePlace.addr ? tracePlace.addr : ''}</div>
                  </div>
                  {tracePlace && tracePlace.mapImg && (
                    <div className={classes.placeMainImgDivMobile}>
                      <img
                        src={
                          /^\b(uploads\/.{1,})\b/gi.test(tracePlace.mapImg)
                            ? `http://61.254.62.162:4002/${tracePlace.mapImg}`
                            : `${tracePlace.mapImg}`
                        }
                        style={{ borderRadius: '20px', width: '100%', height: '100%', cursor: 'pointer', WebkitTouchCallout: 'none' }}
                        alt={`${tracePlace.name}`}
                        onClick={this.openImgView}
                        onContextMenu={(e) => e.preventDefault()}
                      />
                      <ImgsViewer
                        imgs={[
                          {
                            src: /^\b(uploads\/.{1,})\b/gi.test(tracePlace.mapImg)
                              ? `http://61.254.62.162:4002/${tracePlace.mapImg}`
                              : `${tracePlace.mapImg}`,
                            alt: `${tracePlace.name}`,
                          },
                        ]}
                        isOpen={isImgViewerOpen}
                        onClose={this.closeImgView}
                        showImgCount={false}
                        closeBtnTitle={'닫기'}
                        spinnerSize={5}
                      />
                    </div>
                  )}
                  <div>
                    <div
                      style={{ wordBreak: 'break-word', whiteSpace: 'pre-line' }}
                      dangerouslySetInnerHTML={{ __html: tracePlace ? tracePlace.desc : '' }}
                    />
                    {tracePlace && tracePlace.link && (
                      <div style={{ paddingTop: '1em' }} className={classes.chipButtonDiv}>
                        <Chip
                          clickable
                          className={classes.placeStampTourBtn}
                          label={
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <span style={{ fontWeight: 'bold', color: '#fff' }}>{tracePlace ? tracePlace.name : ''} 스탬프투어</span>
                              &nbsp;
                              <img
                                src={'/images/mypage/tracedetail/ic_arrow@2x.png'}
                                style={{ width: '1em', height: '0.5em' }}
                                alt={'arrow_ic'}
                              />
                            </div>
                          }
                          onClick={() => {
                            window.open(tracePlace.link, '_blank');
                          }}
                        />
                      </div>
                    )}
                  </div>
                </Grid>
                {tracePlace && tracePlace.mapImg && (
                  <Grid item container xs={12} sm={12} md={4} className={classes.placeMainImgDivWeb}>
                    <div style={{ display: 'table', width: '100%', height: '100%' }}>
                      <div style={{ display: 'table-cell', verticalAlign: 'middle' }}>
                        <img
                          src={
                            /^\b(uploads\/.{1,})\b/gi.test(tracePlace.mapImg)
                              ? `http://61.254.62.162:4002/${tracePlace.mapImg}`
                              : `${tracePlace.mapImg}`
                          }
                          alt={`${tracePlace.name}`}
                          onClick={this.openImgView}
                          title={'클릭 시 이미지를 크게 볼 수 있습니다.'}
                          onContextMenu={(e) => e.preventDefault()}
                          style={{ WebkitTouchCallout: 'none' }}
                        />
                      </div>
                    </div>
                    <ImgsViewer
                      imgs={[
                        {
                          src: /^\b(uploads\/.{1,})\b/gi.test(tracePlace.mapImg)
                            ? `http://61.254.62.162:4002/${tracePlace.mapImg}`
                            : `${tracePlace.mapImg}`,

                          // src: '/images/mypage/tracedetail/ic_arrow@2x.png',
                          alt: `${tracePlace.name}`,
                        },
                      ]}
                      isOpen={isImgViewerOpen}
                      onClose={this.closeImgView}
                      showImgCount={false}
                      closeBtnTitle={'닫기'}
                    />
                  </Grid>
                )}
              </Grid>
              {tracePlace && tracePlace.stamp && (
                <div className={classes.courseDiv}>
                  <Grid container spacing={2}>
                    {tracePlace.stamp.map((item, idx) => {
                      return (
                        <Grid
                          onClick={() => {
                            if (this.isVisit(item.id)) {
                              this.modalOpen(item);
                            }
                          }}
                          item
                          xs={6}
                          sm={6}
                          md={3}
                          key={idx}
                          className={classes.courseItemGrid}
                        >
                          {/^\b(uploads\/.{1,})\b/gi.test(item.img) ? (
                            <img
                              src={`http://61.254.62.162:4002/${item.img}`}
                              className={classes.courseImg}
                              //스탬프 이미지 우클릭 다운로드 방지
                              onContextMenu={(e) => e.preventDefault()}
                              style={{ opacity: this.isVisit(item.id) ? 1.0 : 0.2 }}
                              alt="코스이미지"
                            />
                          ) : (
                            <img
                              src={`${item.img}`}
                              className={classes.courseImg}
                              //스탬프 이미지 우클릭 다운로드 방지
                              onContextMenu={(e) => e.preventDefault()}
                              style={{ opacity: this.isVisit(item.id) ? 1.0 : 0.2 }}
                              alt="코스이미지"
                            />
                          )}

                          <span className={classes.courseName}>{item.name}</span>
                        </Grid>
                      );
                    })}
                  </Grid>
                </div>
              )}
            </CardContent>
          </Card>
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(TraceDetail);
